'use client'

import CommunityDiscordChannelInput from '@/components/_community/forms/settings/components/inputs/discord-role/community-discord-channel-input'
import CommunityDiscordServerInput from '@/components/_community/forms/settings/components/inputs/discord-role/community-discord-server-input'
import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'
import { LoaderCircle } from 'lucide-react'
import JoinLinkServiceField from './fields/join-link-service'
import JoinLinkUrl from './fields/join-link-url'

export default function JoinLinkForm({ form, formStep, isSubmitting }) {
  const [joinLinkServiceValue, joinLinkUrlValue] = form.watch([
    'joinLinkService',
    'joinLinkUrl',
  ])

  const isDisabled = isSubmitting || !joinLinkServiceValue || !joinLinkUrlValue

  return (
    <div
      className={cn('flex h-full w-full flex-col justify-center gap-5 pb-6', {
        hidden: formStep !== 3,
      })}
    >
      <div className="flex h-full grow flex-col justify-between gap-4">
        <h5 className="text-h-5-sm font-medium">
          Where does your community hang out?
        </h5>
        <p className="text-sm text-neutral-blue-200">
          Link the primary platform where your community gets together to chat.
        </p>

        <div className="mt-4 flex h-full flex-col">
          <JoinLinkServiceField form={form} />
          {joinLinkServiceValue && <JoinLinkUrl form={form} />}
        </div>

        <div className="mt-2">
          <CommunityDiscordServerInput form={form} />
        </div>

        <div className="mt-2">
          <CommunityDiscordChannelInput
            form={form}
            className="md:max-w-[533px]"
          />
        </div>

        <div className="mt-2 flex justify-start gap-2">
          <Button type="submit" variant="outline" disabled={isSubmitting}>
            Do it later
          </Button>
          <Button
            type="submit"
            className="flex items-center gap-2"
            disabled={isDisabled}
          >
            {isSubmitting && (
              <LoaderCircle className="size-5 animate-spin"></LoaderCircle>
            )}
            Next
          </Button>
        </div>
      </div>
    </div>
  )
}
